<template>
    <div class="p-2" style="width:250px">
      <vs-row vs-type="flex" vs-justify="center">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" >
          {{$t('Actual')}} : {{ params.value.equipmentCode }}
        </vs-col>
      </vs-row>
      <div class="vx-row ml-2 mr-2 mt-2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
        <div class="mt-2">    
          <form-label>{{$t('GradeControl.Equipment.Name')}}</form-label>
          <vs-checkbox v-model="isContractual" class="mb-2">{{$t('GradeControl.Contractual')}}</vs-checkbox>
          <vs-checkbox v-model="onlyActive" class="mb-2">{{$t('GradeControl.Equipment.OnlyActive')}}</vs-checkbox>
          <v-select
            label="code"
            :options="equipments"
            :reduce="equipment => equipment.code"
            v-model="equipmentCode"
            @input="setSelected"
            class="w-full"
            name="equipmentCode">
            <template #option="{ code, company }">
              {{ code }} - {{ company }}
            </template>
          </v-select>
        </div>
      </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import { FormLabel } from "../../../../shared/components";

export default {
  name: 'EquipmentCodeCellEditor',
  data() {
    return {
      isContractual: null,
      onlyActive : true,
      equipmentCode: null
    }
  },
  computed: {
    equipments() {
      return this.params.context.componentParent.equipments.filter(e => e.isContractual === this.isContractual && (!this.onlyActive || e.isActive));
    }
  },
  watch: {
    isContractual() {
      const selectedEquipment = this.params.context.componentParent.equipments.find(e => e.code === this.equipmentCode && e.isContractual === this.isContractual);
      
      if (!selectedEquipment) {
        this.equipmentCode = null;
      }
    } 
  },
  components: {
    'v-select': vSelect,
    FormLabel
  },
  created() {
    this.isContractual = this.params.value.isContractual;
    this.equipmentCode = this.params.value.equipmentCode;
    const selectedEquipment = this.params.context.componentParent.equipments.find(e => e.code === this.equipmentCode);
    if (selectedEquipment) {
      this.onlyActive = selectedEquipment.isActive;
    } else {
      this.onlyActive = true;
    }
  },
  methods: {
    getValue() {
      const equipmentCode = this.equipmentCode;
      const isContractual = this.isContractual;
      return {
        equipmentCode,
        isContractual
      };
    },
    isPopup() {
      return true;
    },
    setSelected(code) {
      this.equipmentCode = code;
      this.params.api.stopEditing();
    }
  }
}
</script>
